export function getTrainingRequestsRecordsFilterObj(forms, pageNumber, pageSize, sortBy, trNo) {
    let
    filterObj,
    { lookupDataStore } = window.provider.common,
    { ORGS } = window.session.jwtSession,
    sanitizedCriteria = {
        sort: sortBy || 'TRID_ASC',
        pageSize: pageSize || 10,
    	pageNumber: pageNumber || 1,
        filterCriteria: {}
    };
    
    if(forms != null) {
        {console.log("value",forms.category.value)}
        {console.log("name",forms.category.name)}
        {console.log("key",forms.category.key)}
        filterObj = {
    		CATEGORY_EQ: getTrainingType(forms.category.value || null),
            //Map school value to ID using Redux
            SCHOOL_EQ: forms.schools.value || null,
            TRID_EQ: forms.trainingRequestsNo.value || null,
            TR_STATUS_EQ: getTrStatusCode(forms.trStatus.value || null),
    		CANDIDATE_NAME_LIKE: forms.studentName.value || null,
            CANDIDATE_USERID_EQ: forms.studentsAfspUserId.value || null,
            CANDIDATE_STUDENT_ID_EQ: forms.studentId.value || null,
            ESTIMATE_START_DATE_EQ: forms.estStartDate.value || null,
            ESTIMATE_END_DATE_EQ: forms.estEndDate.value || null,
            ACTUAL_START_DATE_EQ: forms.actStartDate.value || null,
            ACTUAL_END_DATE_EQ: forms.actEndDate.value || null,
    		PHOTO_UPLOAD_EQ: forms.photoUpload.value === '' ? null : forms.photoUpload.value,
    		COMPLETION_STATUS_EQ: forms.completionStatusRequired.value === '' ? null : forms.completionStatusRequired.value,
    		VALIDATION_REQ_EQ: forms.validationRequired.value === '' ? null : forms.validationRequired.value,
            REVALIDATION_REQ_EQ: forms.reValidationRequired.value === '' ? null : forms.reValidationRequired.value,
    		EXPIRATION_STATUS_EQ: forms.expirationStatus.value === '' ? null : forms.expirationStatus.value,
            EVENTID_EQ: forms.eventId.value || null,
        };

        for(let p in filterObj)
            if(filterObj[p] != null)
                sanitizedCriteria.filterCriteria[p] = filterObj[p];
    }

    if(trNo != null) sanitizedCriteria.filterCriteria = { TRID_EQ: trNo };
    return sanitizedCriteria;
}

const getTrStatusCode = v => {
    const { provider_training_status } = window.provider.common.lookupDataStore;
    return v == null ? null : provider_training_status.find(t => t.name === v).value;
}


const getCategory = v => {
    const { CATEGORY_EQ } = window.provider.common.lookupDataStore;
    return v == null ? null : CATEGORY_EQ.find(t => t.name === v).value;
}

function getTrainingType(trainingValue){
    var trainingType = null;
    
    if (window.provider.common) {
        
        var typeList = window.provider.common.lookupDataStore["CATEGORY_CD"].sort(function(a,b){
            return a.name.localeCompare(b.name);
          });
          typeList.forEach(type => {
            if (type.name === trainingValue) {
                trainingType = type.value;  
            }
          })
        }
        {console.log("Training Type:", trainingType)}
    return trainingType;
  }

